<!-- =========================================================================================
  File Name: addSidebarView.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "EDIT" }} LOCATION</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6 pb-0">

        <!-- NAME -->
        <vs-input label="Name *" v-model="dataName" @input="checkName" class="mt-5 w-full" name="item-name" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-name')">{{ errors.first('item-name') }}</span>
        <span class="text-danger text-sm" v-if="LocationDuplicate>0">Name already has been taken!</span>
                <!-- EMAIL -->
        <vs-input label="Email" v-model="dataEmail" class="mt-5 w-full" :name="$t('user.add.email')" v-validate="'email'" />
        <span class="text-danger text-sm" v-show="errors.has($t('user.add.email'))">{{ errors.first($t('user.add.email')) }}</span>
        <!-- PHONE -->
        <vs-input :label="$t('user.add.phone_no')" v-model="dataPhone"  @input="acceptNumber" class="mt-5 w-full" :name="$t('user.add.phone_no')"/>
        <span class="text-danger text-sm" v-show="errors.has($t('user.add.phone_no'))">{{ errors.first($t('user.add.phone_no')) }}</span>
     <!-- Latitude -->
        <vs-input label="Latitude " v-model="dataLatitude" class="mt-5 w-full"  />
             <!-- Longitude -->
        <vs-input label="Longitude " v-model="dataLongitude" class="mt-5 w-full"   />
              <!-- Pin Url -->
        <vs-input label="Pin Url " v-model="dataPin" class="mt-5 w-full"  />
         <!-- Address -->
        <vs-input label="Address " v-model="dataAddress" class="mt-5 w-full"  /><br>
         <label class="vs-select--label w-full">Select Timezone *</label>
        <v-select  label="name"   :closeOnSelect="true" v-model="dataTimezone"  :options="timezones"  /><br>
         <label class="vs-select--label w-full">Managers</label>
        <v-select  label="name"  multiple :closeOnSelect="true" v-model="dataManager"  :options="managers"   /><br>
      </div>

        <div class="flex items-center justify-between px-6">
        <h5>SCHEDULE</h5>
        <!-- <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "UPDATE" }} SCHEDULE</h4> -->
    </div>
    <vs-divider class="mb-0"></vs-divider>
     <div>
      <!-- NAME -->
      <!-- <vs-row class="pl-5 pr-10 pb-0">
     <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
           <vs-input label="Schedule Name"  v-model="currrent_schedule.name" class="mt-5 w-full" name="item-name" v-validate="'required'"/>
        <span class="text-danger text-sm" v-show="errors.has('item-name')">{{ errors.first('item-name') }}</span>
     </vs-col>
</vs-row> -->
    <div class="slot-fields p-6 pt-0" v-for="(date, index) in currrent_schedule.dates" :key="index">
        <br>{{index}}
    <div class="slot-fields" v-for="(item, dayindex) in date" :key="dayindex">
    <small style="color:red">{{getTime(index,dayindex,item.start_time,item.end_time)}}</small>
    <vs-row>
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
    <flat-pickr v-model="item.start_time" :config="configdateTimePicker" class="timepicker" name="start_time" placeholder="Start time"/>
   </vs-col>
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
    <flat-pickr v-model="item.end_time" :config="configdateTimePicker" class="timepicker" name="end_time" placeholder="End time"/>
    <span class="danger" @click="inputRemove(index,dayindex)" style="color:red">x</span>
   </vs-col>
    <!-- <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
    <span class="danger" @click="inputRemove(index,dayindex)" style="color:red">x</span>
   </vs-col> -->
  </vs-row>
    </div>
    <div  class="slot-actions pr-2 mt-1 " style="float:right;clear: both">
    <vs-button color="primary" size="small" @click="inputAdd(index)"><feather-icon icon="PlusIcon" svgClasses="h-2 w-2"/></vs-button>
     </div>
        </div>
      </div>
    </component>
    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {UPDATE_LOCATION,ALL_TIMEZONES,CREATE_LOCATION,CREATE_SCHEDULE,UPDATE_SCHEDULE,ALL_MANAGERS,CHECK_LOCATION } from '@/graphql'
import Datepicker from 'vuejs-datepicker';
import vSelect from 'vue-select'
import moment from 'moment'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
    Datepicker,
    flatPickr,
    moment
  },
  data () {
    return {
    timezones : [],
    // {"label":"Eastern Standard Time (EST)","id":"EST"},
    // {"label":"Central Standard Time	(CST)","id":"CST"},
    // {"label":"Pacific Standard Time	(PST)","id":"PST"},
    // {"label":"Mountain Standard Time (MST)","id":"MST"},
    // {"label":"Alaska Standard Time (AKST)","id":"AKST"},
    // {"label":"Hawaii Standard Time	(AHST)","id":"AHST"},

     managers:[],
     dataManager:'',
     dataTimezone:'',
     dataAddress:'',
     dataPhone:'',
     dataEmail:'',
     dataPin:'',
     dataLatitude:'',
     dataLongitude:'',
      dataId: null,
      dataName: '',
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      currrent_schedule:
        {
          "id": "",
          "name": "",
          dates: {
            Monday: [
              {
                "start_time": "",
                "end_time": "",
              }
            ],
            Tuesday: [
              {
              "start_time": "",
              "end_time": "",
            }
            ],
            Wednesday: [
              {
              "start_time": "",
              "end_time": "",
            }
            ],
           Thursday: [
            {
              "start_time": "",
              "end_time": "",
            }
            ],
          Friday: [
            {
              "start_time": "",
              "end_time": "",
            }
            ],
          Saturday: [{
              "start_time": "",
              "end_time": "",
            }
            ],
          Sunday: [{
              "start_time": "",
              "end_time": "",
            }
            ],
          }
        },
         configdateTimePicker: {
        enableTime: true,
        noCalendar: true,
        timeFormat: "H:i",
        time_24hr: false,
        altInput: true,
        dateFormat: "H:i",
      },
      deletedschedules:[],
      LocationDuplicate:0,
    }

  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const {id, name,timezone,schedule,managers,email,phone,longitude,latitude,pin_url,address} = JSON.parse(JSON.stringify(this.data))
        var getmanager = [];
        var getmanagerids = [];
        for (let j = 0; j< managers.length; j++) {

          getmanagerids.push(managers[j].id)
          var getfullname = managers[j].fname+' '+managers[j].lname+' - '+managers[j].email
          managers[j].name = getfullname;
          getmanager.push(managers[j])
        }
        this.Mangerlist=getmanagerids
        this.dataManager = getmanager
        this.dataId = id
        this.dataName = name
        this.dataEmail = email
        this.dataPhone = phone
        this.dataLongitude = longitude
        this.dataLatitude = latitude
        this.dataPin = pin_url
        this.dataAddress = address
        this.dataTimezone= timezone
        this.current_cameras=[]
        this.currrent_schedule.id = schedule.id
        this.currrent_schedule.name = schedule.name
        this.currrent_schedule.dates= {
            Monday: [],
            Tuesday: [],
            Wednesday: [],
            Thursday: [],
            Friday: [],
            Saturday: [],
            Sunday: [],
          }
       var getarry=[]
       for (let i = 0; i <schedule.scheduledates.length; i++) {
        //  delete scheduledates[i].id
          delete schedule.scheduledates[i].__typename
          getarry.push(schedule.scheduledates[i])
       }
       for (let i = 0; i < getarry.length; i++) {
          var day = getarry[i].day;
        if(day=="Monday"){
          this.currrent_schedule.dates.Monday.push(getarry[i])
        }
        if(day=="Tuesday"){
          this.currrent_schedule.dates.Tuesday.push(getarry[i])
        }
        if(day=="Wednesday"){
          this.currrent_schedule.dates.Wednesday.push(getarry[i])
        }
        if(day=="Thursday"){
          this.currrent_schedule.dates.Thursday.push(getarry[i])
        }
        if(day=="Friday"){
          this.currrent_schedule.dates.Friday.push(getarry[i])
        }
        if(day=="Saturday"){
          this.currrent_schedule.dates.Saturday.push(getarry[i])
        }
        if(day=="Sunday"){
          this.currrent_schedule.dates.Sunday.push(getarry[i])
        }
       }

        this.initValues()
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
      this.currrent_schedule.name='Location'+' '+this.dataName+' '+'Schedule'
      return !this.errors.any() && this.dataName && this.dataTimezone && this.currrent_schedule.name && this.LocationDuplicate===0
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
      checkName(){
       this.$apollo
       .mutate({
        mutation: CHECK_LOCATION,
        variables: {
        id:this.dataId,
        name: this.dataName,
     },
      })
        .then(response => {
         this.LocationDuplicate=response.data.checkLocationName.counter
      })
    },
      acceptNumber() {
      let x = this.dataPhone
        .replace(/\D/g, "")
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);

      this.dataPhone = !x[2]
        ? x[1]
        : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
    },
     getTime(day,index,start_time,end_time){
    var space="  "
    if(start_time.toString()!='' && end_time.toString()!=''){
    if (end_time > start_time){
       return ""
    }
    else
    {
     return "End Time is Less than Start Time at " + day +  space + (index+1)
    }
    }
    },
    inputAdd(dayindex) {
      var index = this.currrent_schedule.dates[dayindex].length
      this.currrent_schedule.dates[dayindex].push({
        "start_time": "",
        "end_time": "",
      });
    },
    inputRemove(index,dayindex) {
      if(this.currrent_schedule.dates[index][dayindex].id){
        this.deletedschedules.push(this.currrent_schedule.dates[index][dayindex].id)
      }
      this.currrent_schedule.dates[index].splice(dayindex, 1);
    },
      StatusSuccess(item,action) {
      this.$vs.notify({
        title: "Loaction",
        text:  item+' '+action+' Successfully!!',
        color: 'success',
        position: 'top-right'
      })
    },
      StatusFail(item,action) {
      this.$vs.notify({
        title: "Loaction",
        text:  item+' '+action,
        color: 'danger',
        position: 'top-right'
      })
    },
     UpdateSuccess() {
      this.$vs.notify({
        title: "Location",
        text: 'Location Update Successfully!',
        color: 'success',
        position: 'top-right'
      })
      },
    initValues () {
      if (this.data.id) return
      this.dataId = null
      this.dataName = ''
       this.currrent_schedule=
        {
          "id": "",
          "name": "",
          dates: {
            Monday: [
              {
                "start_time": "",
                "end_time": "",
              }
            ],
            Tuesday: [
              {
              "start_time": "",
              "end_time": "",
            }
            ],
            Wednesday: [
              {
              "start_time": "",
              "end_time": "",
            }
            ],
           Thursday: [
            {
              "start_time": "",
              "end_time": "",
            }
            ],
          Friday: [
            {
              "start_time": "",
              "end_time": "",
            }
            ],
          Saturday: [{
              "start_time": "",
              "end_time": "",
            }
            ],
          Sunday: [{
              "start_time": "",
              "end_time": "",
            }
            ],
          }
        },
      this.deletedschedules=[]
      this.dataManager=[]
    },
    submitData () {
          var getmanagerids = [];
          for (let j = 0; j< this.dataManager.length; j++) {
          var getid = this.dataManager[j].id
          getmanagerids.push(getid)
        }
      var finalschedule=[]
     for (let i = 0; i <this.currrent_schedule.dates.Monday.length; i++) {
       var element = this.currrent_schedule.dates.Monday[i];
       if(element['start_time'] != '' && element['end_time'] != '' )
          {
            element["day"] = "Monday"
            finalschedule.push(element)
          }
    }
    for (let i = 0; i <this.currrent_schedule.dates.Tuesday.length; i++) {
       var element = this.currrent_schedule.dates.Tuesday[i];
       if(element['start_time'] != '' && element['end_time'] != '' )
          {
              element["day"] = "Tuesday"
              finalschedule.push(element)
          }
      }
    for (let i = 0; i <this.currrent_schedule.dates.Wednesday.length; i++) {
       var element = this.currrent_schedule.dates.Wednesday[i];
        if(element['start_time'] != '' && element['end_time'] != '' )
          {
                element["day"] = "Wednesday"
                finalschedule.push(element)
          }
    }
    for (let i = 0; i <this.currrent_schedule.dates.Thursday.length; i++) {
       var element = this.currrent_schedule.dates.Thursday[i];
        if(element['start_time'] != '' && element['end_time'] != '' )
          {
                 element["day"] = "Thursday"
                 finalschedule.push(element)
          }
    }
    for (let i = 0; i <this.currrent_schedule.dates.Friday.length; i++) {
       var element = this.currrent_schedule.dates.Friday[i];
       if(element['start_time'] != '' && element['end_time'] != '' )
        {
          element["day"] = "Friday"
          finalschedule.push(element)
        }
    }
     for (let i = 0; i <this.currrent_schedule.dates.Saturday.length; i++) {
       var element = this.currrent_schedule.dates.Saturday[i];
       if(element['start_time'] != '' && element['end_time'] != '' )
        {
          element["day"] = "Saturday"
          finalschedule.push(element)
        }
    }
     for (let i = 0; i <this.currrent_schedule.dates.Sunday.length; i++) {
       var element = this.currrent_schedule.dates.Sunday[i];
      if(element['start_time'] != '' && element['end_time'] != '' )
       {
         element["day"] = "Sunday"
         finalschedule.push(element)
       }
    }
    var error=0
    checkSchedule(finalschedule);
   function checkSchedule(finalschedule){
      if(finalschedule.length>0){
      for (let i = 0; i < finalschedule.length; i++) {
      if (finalschedule[i].end_time <= finalschedule[i].start_time){
         error++
      }
    }
    }
    else{
      error++
    }
    }
      this.$validator.validateAll().then(result => {
        if (result && error==0) {
          if (this.dataId !== null && this.dataId >= 0) {
           this.$apollo
          .mutate({
           mutation: UPDATE_LOCATION,
           variables: {
            id :this.dataId,
            name: this.dataName,
            email:this.dataEmail,
            phone:this.dataPhone,
            latitude:this.dataLatitude,
            longitude:this.dataLongitude,
            pin_url:this.dataPin,
            address:this.dataAddress,
            timezone:this.dataTimezone.id,
            managers: getmanagerids,
          }
        })
        .then(response => {
            if (response) {
            this.StatusSuccess("Location","Updated")
            this.$emit('closeSidebar')
            this.initValues()
          }
        }) .catch(error => {
            this.StatusFail("Location","Update Fail")
            console.log(error)
      });
       if (result && error==0) {
          if (this.currrent_schedule.id !== "" && this.currrent_schedule.id>= 0) {
          var newschedule=[]
          for (let i = 0; i <finalschedule.length; i++) {
           if(!finalschedule[i].id){
             newschedule.push(finalschedule[i])
           }
         }
       finalschedule=finalschedule.filter(function(item) {
        if(item.id)
        {
         return true
        }
        else{
          return false
        }
        })
        this.$apollo
          .mutate({
           mutation: UPDATE_SCHEDULE,
          variables: {
          id:this.currrent_schedule.id,
          name:this.currrent_schedule.name,
          scheduledates: {
          update:finalschedule,
          create:newschedule,
          delete:this.deletedschedules,
          },
          }
        })
        .then(response => {
          if (response){
            // this.StatusSuccess("Schedule","Updated")
            this.$emit('closeSidebar')
            this.initValues()
          }
        }) .catch(error => {
           this.StatusSuccess("Schedule","Fail")
          console.log(error)
      });
        }
        }
         }
        else {
          this.$apollo
          .mutate({
           mutation: CREATE_LOCATION,
          variables: {
          name:this.dataName,
          email:this.dataEmail,
          phone:this.dataPhone,
          latitude:this.dataLatitude,
          longitude:this.dataLongitude,
          pin_url:this.dataPin,
          address:this.dataAddress,
          timezone:this.dataTimezone.id,
          managers: getmanagerids,
          }
        })
        .then(response => {
          if (response){
          var location_id=response.data.createLocation.id
          var location_name=response.data.createLocation.name
          this.StatusSuccess("Loaction","Created")
          this.$apollo
          .mutate({
           mutation: CREATE_SCHEDULE,
          variables: {
          name:this.currrent_schedule.name,
          scheduledates: {
          create:finalschedule
          },
          }
        })
        .then(response => {
          if (response){
          this.$apollo
          .mutate({
           mutation: UPDATE_LOCATION,
           variables: {
            id :location_id,
            name:location_name,
            schedule_id:response.data.createSchedule.id
          }
        })
        .then(response => {
          if (response){
            this.$emit('closeSidebar')
            this.initValues()
            setInterval(() => this.$emit('gotoprofile',location_id), 1000);
            // this.$emit('getdata',true)
          }
        })
      }
        }) .catch(error => {
            this.StatusFail("Location","Update Fail")
        });
          }
        }) .catch(error => {
           this.StatusFail("Schedule","Fail")
      });
          }
          // this.$emit('closeSidebar')
          // this.initValues()
        }
        else{
           this.StatusFail("Schedule is Required","Failed")
        }
      })
    },
  },

created(){
   var managers = [];
     this.$apollo
      .mutate({
        mutation: ALL_TIMEZONES,
      })
      .then(response => {
          this.timezones=response.data.allTimezone
      })
   this.$apollo
      .mutate({
        mutation: ALL_MANAGERS,
      })
      .then(response => {
          for (let i = 0; i<response.data.role.users.length; i++) {
          var fullname = response.data.role.users[i].fname+' '+response.data.role.users[i].lname+' - '+response.data.role.users[i].email
          response.data.role.users[i].name = fullname;
          managers.push(response.data.role.users[i])
        }
         this.managers=managers
      })
}
}

</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
